import * as React from "react";
import spinner from "../images/Spinner.gif";

const FinSpinner: React.FunctionComponent = () => {
  return (
    <div className="finSpinner">
      <img src={spinner} alt="finSpinner" />
    </div>
  );
};

export default FinSpinner;
